// whocare: lazy route components of the article display side, in the shape of the stock
// features/ui/util/async-components (a function returning the dynamic import; <WrappedRoute> / <Bundle> load it).
// The reading view is split out by article_reader.tsx itself.

export function AccountArticles() {
  return import('./account_articles');
}

export function ArticleRedirect() {
  return import('./article_redirect');
}
